<template>
  <div class="content">
    <div class="detail-drawer">
      <div class="drawer-title-icon">
        <i class="el-icon-close" style="cursor: pointer" @click="$emit('closeDrawer', true)"></i>
      </div>
      <div class="drawer-title-header">
        <div class="drawer-title-text">定向包名称: {{ model.directPackageName || '-' }}</div>
      </div>
    </div>
    <el-tabs v-model="activeName" tab-position="left" style="height: 100%" class="drawer-tabs">
      <el-tab-pane name="detail">
        <span slot="label">
          <i class="el-icon-view"></i> 详情
        </span>
        <div class="drawer-tabs-content">
          <div class="title-text">基本信息</div>
          <el-form label-width="110px" label-position="left">
            <el-row>
              <el-col :span="12">
                <el-form-item label="定向包名称">{{ model.directPackageName || '-' }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="广告位">{{ model.spaceName || '-'}}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="投放渠道">{{ model.channelName || '-' }}</el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="title-text">定向信息</div>
          <DirectionDetail :model="{ ...model }" />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import DirectionDetail from '@/components/scheduleDirection/DirectionDetail.vue'

export default {
  components: {
    DirectionDetail
  },
  props: {
    model: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      activeName: 'detail'
    }
  },
  methods: {}
}
</script>

<style lang="stylus" scoped>
.content
  display flex
  flex-direction column
.detail-drawer
  display flex
.drawer-title
  display flex
  flex-direction row
  align-items center
  height 53px
  line-height 53px
.drawer-title-icon
  width 56px
  text-align center
  background rgba(10, 33, 64, 0.831372549019608)
  color #fff
  height 53px
  line-height 53px
.drawer-title-header
  display flex
  justify-content space-between
  width calc(100% - 56px)
  .drawer-title-text
    line-height 53px
    padding 0px 16px
    font-size 14px
.drawer-tabs-content
  margin 0 16px
.drawer-tabs> >>>.el-tabs__header
  margin 0
  padding 0
  width 55px
  border-bottom none
.drawer-tabs> >>>.el-tabs__content
  border-top 1px solid #f0f2f5
  border-left 1px solid #f0f2f5
  height calc(100vh - 60px)
  overflow auto
.drawer-tabs> >>>.el-tabs__header .el-tabs__active-bar
  display none
.drawer-tabs> >>>.el-tabs__header .el-tabs__item
  padding 0 !important
  height 53px
.drawer-tabs> >>>.el-tabs__header .el-tabs__item.is-active
  background-color #ff8b00
  color #fff
.drawer-tabs> >>>.el-tabs__header .el-tabs__item :hover
  color rgba(0, 0, 0, 0.65)
.drawer-tabs> >>>.el-tabs__header .el-tabs__item span
  font-size 14px
  display flex
  flex-direction column
  align-items center
  justify-content center
  width 56px
  height 53px
  line-height 2
  font-weight bold
.drawer-tabs>>>.tab-left
  width 100%
  display flex
  height 100%
.el-form-item
  margin-bottom 0px
</style>
